import { createGlobalStyle } from 'styled-components';

const GlobalStyled = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    background-color: ${({ theme }) => theme.color.fifth};
    box-sizing: border-box;
    font-family: 'Merriweather', serif;
    /* font-family: 'Nova Flat', cursive; */
  }
  h1,h2,h3,h4,h5,p,span,a{
    margin:0;
    padding: 0;
    color:white;
  }
  h1{
    font-size:32px;
  }
  h2{
    font-size:24px;
  }
  h3{
    font-size:20px;
  }

  h4{
    font-size:16px;
  }
  p{
    font-size: 14px;
  }a{
    text-decoration: none;
  }
`;

export default GlobalStyled;